
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import OptOutForm from './OptOutForm';

const OptOutSection: React.FC = () => {
  const [nanoid, setNanoid] = useState<string | null>(null);
  const location = useLocation();
  
  useEffect(() => {
    // Get URL parameters when component mounts
    const params = new URLSearchParams(window.location.search);
    
    // Check if 't' parameter exists and set nanoid
    const tParam = params.get('t');
    if (tParam) {
      setNanoid(tParam);
    }
  }, [location.search]);

  return (
    <section id="opt-out-form" className="px-4 py-16 bg-white bg-opacity-50">
      <div className="container mx-auto max-w-5xl">
        <div className="text-center mb-12 animate-fade-in">
          <h2 className="text-2xl md:text-3xl font-bold text-optout-text mb-4">
            Opt Out of SMS Messages
          </h2>
          <p className="text-optout-lighttext max-w-2xl mx-auto text-balance">
            Complete the form below to opt out of receiving SMS marketing messages.
            Your request will be processed within 10 business days.
          </p>
        </div>
        
        <OptOutForm nanoidValue={nanoid} />
      </div>
    </section>
  );
};

export default OptOutSection;
